<template>
  <b-modal
    id="add-faculty-modal"
    ref="addFacultyModal"
    title="เพิ่มรายการคณะ"
    :ok-disabled="this.$v.form.$anyError"
    ok-title="บันทึกข้อมูล"
    cancel-title="ยกเลิก"
    @ok="submit"
  >
    <b-form-group label-cols="4" label-cols-lg="3" label="ชื่อคณะ">
      <b-form-input v-model="$v.form.name.$model" :state="$v.form.name.$dirty ? !$v.form.name.$error : null" />
    </b-form-group>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      form: {
        name: ''
      }
    }
  },
  methods: {
    async submit (event) {
      event.preventDefault()

      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }

      try {
        await this.$store.dispatch('faculty/createFaculty', this.form)
        this.$bvToast.toast('เพิ่มรายการคณะสำเร็จ', {
          title: 'แจ้งเตือน',
          variant: 'success',
          solid: true
        })

        this.$nextTick(() => { this.$refs.addFacultyModal.hide() })

        this.form = { name: '' }
        this.$v.form.$reset()
      } catch (_) {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      }
    }
  },
  validations: {
    form: {
      name: { required }
    }
  }
}
</script>
